<!-- begin:: Content Head -->
<div class="kt-subheader kt-grid__item" [ngClass]="{'kt-container--clear': clear}" [hidden]="subheaderService.disabled$ | async" id="kt_subheader">
	<div class="kt-container" [ngClass]="{'kt-container--fluid': fluid}">
		<div class="kt-subheader__main col-11">
			<h3 *ngIf="title" class="kt-subheader__title" >{{title}}</h3>
			<!--
			* Subheader -> Added Divider
			* @author Rosa Korse
			* @since 2019-11-19
			-->
			<span class="kt-subheader__separator kt-subheader__separator--v" *ngIf="breadcrumbs.length > 0 || breadcrumbDashboard !== ''"></span>

			<div class="kt-subheader__breadcrumbs" *ngIf="breadcrumbDashboard !== ''">
				<h3 *ngIf="title" class="kt-subheader__title" >{{breadcrumbDashboard}}</h3>
			</div>

			<div class="kt-subheader__breadcrumbs" *ngIf="breadcrumbs.length > 0">
				<ng-container *ngFor="let item of breadcrumbs | slice:1">
					<span class="kt-subheader__breadcrumbs-separator"></span>
					<a [routerLink]="item.page" [queryParams]="item.queryParams" class="kt-subheader__breadcrumbs-link">
						{{item.title}}
					</a>
				</ng-container>
			</div>
		</div>
		<div class="col-1" style="margin-top: 15px;" >
			<a href="javascript:void(0)" class="actionButton" *ngIf="!isfavorite && breadcrumbs.length > 0" (click)="registerFavorite(actual.page)"  class="button"  matTooltip="Add to Favorites">
				<mat-icon class="actionButton"><em class="far fa-star"> </em></mat-icon>
			</a>
			<a href="javascript:void(0)" class="actionButton" *ngIf="isfavorite && breadcrumbs.length > 0" (click)="removeFavorite(actual.page)"  class="button"  matTooltip="Remove from Favorites">
				<mat-icon class="actionButton" ><em class="fa fa-star"> </em></mat-icon>
			</a>
			<a href="javascript:void(0)" class="actionButton" *ngIf="hasFyffesPediaAccess" (click)="onCustomerSupportOpen()"  class="button"  matTooltip="FyffesPedia">
				<mat-icon class="actionButton"><em class="far fa-comment-dots"> </em></mat-icon>
			</a>
		</div>
		<div class="kt-subheader__toolbar">
			<div class="kt-subheader__wrapper">

			</div>
		</div>
	</div>
</div>
<!-- end:: Content Head -->
